import React, { useState, useCallback, Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import Cropper from 'react-easy-crop'
import UploadCropImagePopup from '../UploadCropImagePopup'
import { GGButton } from '../../../shared/new_components/GGButton'

const ThumbnailsCrop = (props) => {
  return (
    <Fragment>
      <div className='banners-header'>
        <div className='text-ds-form-label'>
          {window.I18n.t('views.golfhub.thumbnails_upload.thumbnail')}
        </div>
        {!props.hideEditButton && <div className='add-padding-left-8'>
          <GGButton
          usePro
          icon='pen-o'
          variant='ghost'
          onClick={() => props.setModalOpen(true)}
        />
        </div>}
      </div>
    </Fragment>
  )
}

export const ThumbnailsCropPopup = (props) => {
  const [ imagePreview, setImagePreview ] = useState({image: props.selectedCourseAlbum.photos[0].course_url, crop: ''})
  const [ crop, setCrop ] = useState({ x: 0, y: 0 })
  const [ zoom, setZoom ] = useState(1)

  useEffect(() => {
    setImagePreview({image: props.selectedCourseAlbum.photos[0].course_url, crop: ''})
  }, [ props.selectedCourseAlbum ])

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    if (imagePreview.image) {
      setImagePreview({...imagePreview, crop: croppedAreaPixels})
    }
  }, [ imagePreview.image ])

  const handleModalClose = () => {
    props.setModalOpen(false)
    setImagePreview({image: props.selectedCourseAlbum.photos[0].course_url, crop: ''})
  }

  const saveImage = () => {
    fetch(imagePreview.image, {
      method: 'GET',
      cache: 'no-store',
    })
    .then((response) => {
      response.blob()
      .then((blob) => {
        const filename = imagePreview.image.split('/')
                          .slice(-1)
                          .join()
        const file = new File([ blob ], filename, {type: blob.type})
        const croppedImage = {image: URL.createObjectURL(file), imageFile: file, crop: imagePreview.crop}

        props.setNewThumbnail(croppedImage)
        handleModalClose()
      })
    })
  }

  return (
    <UploadCropImagePopup
      isOpen={props.modalOpen}
      onClose={() => handleModalClose()}
      onConfirm={() => saveImage()}
      isConfirmDisabled={!imagePreview.image}
      isUpload={false}
      confirmText={window.I18n.t('views.golfhub.modal.done')}
      title={window.I18n.t('views.golfhub.add_thumbnail_photo')}
      imagePreviewSrc={imagePreview.image}
      imagePreviewComponent={
        <div className='crop-container'>
          <Cropper
            image={imagePreview.image}
            crop={crop}
            zoom={zoom}
            aspect={16 / 9}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom} />
        </div>}
      imagePreviewHeader={window.I18n.t('views.golfhub.thumbnails_upload.thumbnail_preview')}
      imagePreviewDetails={window.I18n.t('views.golfhub.image_preview_details')}
      photoFormats={window.I18n.t('views.golfhub.accepted_formats')}
      photoRequirements={window.I18n.t('views.golfhub.thumbnail_acceptable_format')}
    />
  )
}

ThumbnailsCrop.propTypes = {
  setModalOpen: PropTypes.func,
  isGgGolfHub: PropTypes.bool,
  hideEditButton: PropTypes.bool,
}

ThumbnailsCropPopup.propTypes = {
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
  selectedCourseAlbum: PropTypes.object,
  newThumbnail: PropTypes.object,
  setNewThumbnail: PropTypes.func,
}

export default ThumbnailsCrop
